import React from 'react';
import { ShoppingCartIcon, CreditCardIcon, DownloadIcon } from 'lucide-react';
export function HowToReceive() {
  const steps = [{
    num: '1',
    title: 'Comprás',
    desc: 'Elegí tu plan y hacé click en el botón de compra.',
    icon: ShoppingCartIcon
  }, {
    num: '2',
    title: 'Pagás',
    desc: 'Completá el pago seguro en segundos.',
    icon: CreditCardIcon
  }, {
    num: '3',
    title: 'Descargás',
    desc: 'Recibís el link de descarga directo a tu email.',
    icon: DownloadIcon
  }];
  return <section className="bg-white py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <h2 className="text-lg md:text-xl font-black text-[#1F3D2B] text-center mb-3 uppercase tracking-tight" data-id="element-78">
          📩 ¿Cómo recibís el material?
        </h2>
        <div className="flex flex-row items-start justify-center gap-3 md:gap-6" data-id="element-79">
          {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center flex-1 max-w-[160px]" data-id="element-80">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#F5F0E6] border-2 border-[#D4A843] flex items-center justify-center mb-1.5" data-id="element-81">
                <step.icon className="w-5 h-5 md:w-6 md:h-6 text-[#D4A843]" strokeWidth={2.5} data-id="element-82" />
              </div>
              <span className="text-[#D4A843] font-black text-lg md:text-xl leading-none" data-id="element-83">
                {step.num}
              </span>
              <span className="font-black text-[#1F3D2B] text-xs md:text-sm uppercase mt-0.5" data-id="element-84">
                {step.title}
              </span>
              <p className="text-gray-600 text-[10px] md:text-xs font-bold mt-0.5 leading-tight" data-id="element-85">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}